import { useCallback } from 'react'
import { useCallStore } from '../stores/callStore'
import { useAuthStore } from '../stores/authStore'
import { useAdaptivePolling } from './useAdaptivePolling'
import { logger } from '../utils/logger'
import type { QueuedCall } from '../types'

interface QueuePollingResponse {
  items: QueuedCall[]
}

/**
 * 着信キューのポーリングカスタムフック
 * WebSocket接続状態に応じてポーリング間隔を自動調整
 */
export function useQueuePolling(wsConnected = false): { fetchQueue: () => Promise<void> } {
  const { user } = useAuthStore()

  const handleSuccess = useCallback((data: QueuePollingResponse) => {
    const serverCalls = data.items || []

    logger.debug('[useQueuePolling] ポーリング結果:', {
      serverCount: serverCalls.length,
      wsConnected: wsConnected ? 'connected' : 'disconnected',
    })

    // reconcileQueueFromServerでキュー同期 + callStatus矛盾修正を一元管理
    useCallStore.getState().reconcileQueueFromServer(serverCalls)
  }, [wsConnected])

  const { refetch } = useAdaptivePolling<QueuePollingResponse>(
    '/api/queue/calls',
    handleSuccess,
    wsConnected,
    {
      enabled: !!user?.organizationId,
      activeInterval: 5000,    // WebSocket切断時: 5秒
      wsInterval: 30000,       // WebSocket接続時: 30秒
      backgroundInterval: 60000, // バックグラウンド: 60秒
    }
  )

  return { fetchQueue: refetch }
}
